/* istanbul ignore file - better tested visually */
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StepIconProps } from '@mui/material/StepIcon';
import { classNames } from '@partful/shared/lib/classNames';
import styles from './VerticalStepIcon.module.scss';

export function VerticalStepIcon({ active, completed, icon }: StepIconProps) {
  if (active) {
    return (
      <div className={classNames(styles.icon, styles.active)}>
        <span aria-current="step">{icon}</span>
      </div>
    );
  }

  if (completed) {
    return (
      <div className={classNames(styles.icon, styles.completed)}>
        <FontAwesomeIcon icon={faCheck} className={classNames(styles.check)} inverse />
      </div>
    );
  }

  return (
    <div className={classNames(styles.icon, styles.disabled)}>
      <span>{icon}</span>
    </div>
  );
}
